// TODO SZ: remove since is not used in a new design

import { GetServerSideProps } from 'next';

import Image from 'next/image';

import { Page } from '@customTypes/page';

import { addApolloState, initializeApollo } from '@lib/apolloClient';

import { MyProfileQuery, StaticBlocksQuery, Basket, Label } from '@graphql/generated';
import { GET_STATIC_BLOCKS } from '@graphql/queries/staticBlock';
import { GET_MY_BASKET } from '@graphql/queries/basket';
import { GET_PROFILE } from '@graphql/queries/profile';
import { GET_MAIN_LABELS } from '@graphql/queries/labels';

import { parseCookies } from '@lib/parseCookies';

import useDeviceType from '@hooks/useDeviceType';

import Layout from '@layouts/CommonLayout';

import Title from '@components/Title';

import AboutAdvantages from '@modules/about/components/AboutAdvantages/AboutAdvantages';
import AdvantageBlock from '@modules/home/components/AdvantageBlock';
import Believe from '@modules/about/components/Believe';

import s from '@styles/pages/About.module.scss';

import cn from 'classnames';

const containerClass = 'container-wide';

const About: Page = () => {
  const { isTablet } = useDeviceType();
  return (
    <>
      <section className={cn(s.root, containerClass)}>
        <div className="container">
          <div className={s.content}>
            <div className={s.image}>
              <Image
                alt="picture"
                src="/images/payment/success.svg"
                layout="responsive"
                width={isTablet ? 2 : 7}
                height={isTablet ? 1 : 2}
                priority
              />
            </div>
            <Title level={2} className={s.title} weight="medium">
              ЛабКлик - цифровой медицинский сервис, объединяющий крупные лабораторные сети
            </Title>
            <AdvantageBlock bgColor={'wheat'} />
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <AboutAdvantages />
        </div>
      </section>

      <section>
        <div className="container">
          <Title level={2} className={s.title} weight="medium">
            Мы есть то, во что мы верим
          </Title>
          <Believe />
        </div>
      </section>
    </>
  );
};

About.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  const cookies = parseCookies(req);

  const apolloClient = initializeApollo({ token: cookies.token });

  await Promise.allSettled([
    apolloClient.query<StaticBlocksQuery>({ query: GET_STATIC_BLOCKS }),
    apolloClient.query<Label>({ query: GET_MAIN_LABELS }),
  ]);

  try {
    await apolloClient.query<MyProfileQuery>({ query: GET_PROFILE });
    await apolloClient.query<Basket>({ query: GET_MY_BASKET });
  } catch (error) {}

  return addApolloState(apolloClient, {
    props: {},
  });
};

export default About;
